document.addEventListener('alpine:init', () => {
    Alpine.data('appSectionNav', () => ({
        in_view: {section_1: false},

        inViewport(id, options = {offset: {top: 0, right: 0, bottom: 0, left: 0}, threshold: 0.25}) {
            const element = document.getElementById(id)
            const {top, right, bottom, left, width, height} = element.getBoundingClientRect()
            const intersection = {
                t: bottom,
                r: window.innerWidth - left,
                b: window.innerHeight - top,
                l: right,
            }

            const threshold = {
                x: options.threshold * width,
                y: options.threshold * height,
            }

            const in_view =
                intersection.t > options.offset.top + threshold.y &&
                intersection.r > options.offset.right + threshold.x &&
                intersection.b > options.offset.bottom + threshold.y &&
                intersection.l > options.offset.left + threshold.x

            if (in_view) this.in_view[id] = true
            else this.in_view[id] = false
            return this.in_view
        }
    }))
})
